<template lang="pug">
section.section.locations
  .section-separator
    h3 {{ $t("locations.title") }}

    .locations__slider.slider
      swiper(ref="swiper-locations", :options="swiper_setting")
        swiperSlide(v-for="(slide, index) in slides", :key="`location-${index}`")
          .slider__image
            img(:src="getImagePath(index)")
          .slider__content
            h4.slider-title {{ slide.title }}
            p {{ slide.description }}

      .arrow.dir--prev
      .arrow.dir--next
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "Locations",

  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiper_setting: {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        effect: "fade",
        speed: 600,
        spaceBetween: 0,
        navigation: {
          prevEl: ".locations__slider .dir--prev",
          nextEl: ".locations__slider .dir--next",
        },
      },

      slides: this.$t("locations.list"),
    };
  },

  methods: {
    getImagePath(id) {
      return require(`@/assets/images/locations/location-${id + 1}.jpg`);
    },
  },
};
</script>
